var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/checkBox.43f71a70.png","uri@2x": __webpack_public_path__ + "static/media/checkBox.b9d3c284.png","uri@3x": __webpack_public_path__ + "static/media/checkBox.41ad35df.png",
    width: 18,
    height: 18
});